import { all } from 'redux-saga/effects';

import payrollProfileWatcher from './payroll-profile-saga';

export default function* rootSaga(action) {
	yield all([payrollProfileWatcher(action)]);
}
